<script setup lang="ts">
import { NBadge } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: string | number
  max?: number
  dot?: boolean
  showZero?: boolean
  processing?: boolean
  type?: 'default' | 'error' | 'success' | 'warning' | 'info'
  color?: string
  offset?: [number, number]
  show?: boolean
}>(), {
  value: undefined,
  max: 99,
  dot: false,
  showZero: false,
  processing: false,
  type: 'default',
  color: undefined,
  offset: undefined,
  show: true,
})

const attrs = useAttrs()
</script>

<template>
  <NBadge
    :value="value"
    :max="max"
    :dot="dot"
    :show-zero="showZero"
    :processing="processing"
    :type="type"
    :color="color"
    :offset="offset"
    :show="show"
    v-bind="attrs"
  >
    <slot />
  </NBadge>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
